
export default {
  name: 'VsPaginationSizes',
  inject: ['pagination', '$t'],
  watch: {
    'pagination.currentSize': {
      immediate: true,
      handler(value) {
        if (value != this.value) {
          this.value = value
          this.updateInputSize()
        }
      }
    },
    value(newValue, oldValue) {
      if (newValue != oldValue) {
        this.pagination.updateSize(newValue)
        this.updateInputSize()
      }
    }
  },
  data() {
    return {
      value: 0
    }
  },
  computed: {
    pageOptions() {
      const text = this.$t('el.pagination.pagesize')
        .replace('/', '')

      return this.pagination.pageSizes
        .map(value => ({ value, text, label: `${value}/${text}` }))
    },
    disabled() {
      return this.pagination.disabled &&
        this.pagination.limit == this.pagination.defaultLimit
    }
  },
  methods: {
    updateInputSize() {
      this.$nextTick(() => {
        const input = this.$el && this.$el.querySelector('input')
        if (input) input.size = input.value.length - 1
      })
    }
  },
  mounted() {
    this.updateInputSize()
  }
}
